import { TooltipOptionInput } from './tooltip-option-input.model';


export class CustomizeToolTipAddInput implements ICustomizeToolTipAddInput {
    /** The auto-generated id of the company details master */
    companyDetailsId!: number;
    /** The user group name with 255 character limit */
    customizeTooltipName!: string;
    tooltipOption!: TooltipOptionInput[];

    constructor(data?: ICustomizeToolTipAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyDetailsId = _data["companyDetailsId"];
            this.customizeTooltipName = _data["customizeTooltipName"];
            if (Array.isArray(_data["tooltipOption"])) {
                this.tooltipOption = [] as any;
                for (let item of _data["tooltipOption"])
                    this.tooltipOption!.push(TooltipOptionInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomizeToolTipAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomizeToolTipAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyDetailsId"] = this.companyDetailsId;
        data["customizeTooltipName"] = this.customizeTooltipName;
        if (Array.isArray(this.tooltipOption)) {
            data["tooltipOption"] = [];
            for (let item of this.tooltipOption)
                data["tooltipOption"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomizeToolTipAddInput {
    /** The auto-generated id of the company details master */
    companyDetailsId: number;
    /** The user group name with 255 character limit */
    customizeTooltipName: string;
    tooltipOption: TooltipOptionInput[];
}

